import { IoMdGlobe } from "react-icons/io";

const MARKET_DISPLAY = {
  latvia: 'Latvia',
  uk: 'United Kingdom',
};

function MarketSelector({ onSelect }) {
  return (
    <div
      className="gallery-modal-overlay"
      style={{
        background: 'rgba(3, 3, 3, 0.9)',
        pointerEvents: 'auto',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          background: 'var(--color-carbon)',
          padding: '2.5rem',
          borderRadius: '1rem',
          textAlign: 'center',
          width: '90%',
          maxWidth: '420px',
        }}
      >
        <IoMdGlobe size={40} color="var(--color-canvas)" style={{ marginBottom: '0.5rem' }} />
        <h2 style={{ marginBottom: '0.5rem' }}>Select your market</h2>
        <p style={{ color: 'var(--color-canvas)', marginBottom: '1.25rem' }}>
          Choose the region you are shopping from to see correct availability.
        </p>
        <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          {Object.entries(MARKET_DISPLAY).map(([key, label]) => (
            <button
              key={key}
              type="button"
              className="btn btn-primary"
              style={{ minWidth: '120px' }}
              onClick={() => onSelect(key)}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default MarketSelector;
